<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Refresh Products</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="cancel()"
    >
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <div class="mb-2 d-flex justify-content-between align-items-center">
    <p class="m-0">Select which product data fields to fetch the latest data for:</p>
    <div class="d-flex align-items-center gap-2">
      <button class="btn btn-sm btn-primary" (click)="toggleAll()">Toggle All</button>
      <button class="btn btn-sm btn-primary" (click)="toggleNone()">Toggle None</button>
    </div>
  </div>
  <div class="row">
    @for (field of availableFields; track field) {
      <div class="col-md-4 col-sm-6">
        <div class="form-check form-switch mb-2">
          <input class="form-check-input"
            type="checkbox"
            role="switch"
            [id]="field"
            [(ngModel)]="selectedFields[field]"
            (change)="updateFields()">
            <label class="form-check-label" [for]="field">{{field}}</label>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
    <button type="button"
      class="btn btn-primary"
      (click)="confirm()"
      [disabled]="fields.length === 0">
      Refresh
    </button>
  </div>